import { defaultMutations } from 'vuex-easy-access'
import { APP_CONFIG } from '../../config.js'
import PlayerAPI from '../../api/player.js'
import PlayerConst from '../../const/player.js'

const state = {
    // [ Preloading ]
    ptracks: [],
    pcollectionName: '',
    pcollectionType: '',
    pcollectionId: 0,
    pcollectionByText: '',
    pcollectionByName: '',
    ///////////////////
    // [ Playing ]
    tracks: [],
    tracksLoadStatus: 0,
    collectionName: '',
    collectionType: '',
    collectionId: 0,
    collectionByText: '',
    collectionByName: '',
    presentSongId: 0,
    lastSongId: 0,
    isPlaying: false,
    audio: new Audio(),
    isPaused: false,
    volume: 0.5,
    timeLapse: false,
    timeBufferSecs: 0,
    timeBufferMins: 0,
    currentTrackTime: 0,
    lastRecordedTrackTime: -1,
    countCheck: 0,
    currentTrackDuration: 0,
    playerIsBuffering: false,
    color: '#8dff97',
    progressPercent: 0,
    continuousPlay: true
}

const mutations = {
    collectionByText(state, payload){
        state.collectionByText = payload.collectionByText
    },
    collectionByName(state, payload){
        state.collectionType = payload.collectionByName
    },
    collectionName(state, payload){
        state.collectionName = payload.collectionName
    },
    collectionType(state, payload){
        state.collectionType = payload.collectionType
    },
    collectionId(state, payload){
        state.collectionId = payload.collectionId
    },
    tracksLoadStatus(state, payload){
        state.tracksLoadStatus = payload.tracksLoadStatus
    },
    tracks(state, payload){
        state.tracks = payload.tracks
    },
    updateLastSongId(state, payload){
        state.lastSongId = payload.lastSongId
    },
    changeVolume(state, payload){
        state.volume = payload.volume;
        state.audio.volume = state.volume
    },
    updateTimeLapse(state, payload){
        state.timeLapse = payload.timeLapse
    },
    updateCountCheck(state, payload){
        state.countCheck = payload.countCheck
    },
    updateAudioCurrentTime(state, payload){
        state.audio.currentTime = payload.currentTime
    },
    updateProgressPercent(state, payload){
        state.audio.currentTime = payload.percent
    },
    updateContinuousPlay(state, payload){
        state.continuousPlay = payload.status
    },
    play (state,payload/*songId = this.presentSongId, type = ''*/) {
        if (state.collectionId != state.pcollectionId) {
            dispatch('playSong', 0)
            return
        }
        if (state.isPlaying && !state.isPaused) {
            if (payload.type !== '') { // next/previous
                state.audio.src = state.tracks[payload.songId].audio;
                state.audio.play();
                // initial track timer
                state.timeBufferMins = 0
                state.currentTrackDuration = 0
                // change player controls icons
                state.isPlaying = true;
                state.isPaused = false
                state.timeLapse = true
                if (state.audio.readyState < PlayerConst.AUDIO_READY_STATE_HAVE_CURRENT_DATA) {
                    // begin buffering of track
                    state.playerIsBuffering = true
                }
                state.audio.addEventListener('loadeddata', () => {
                    state.playerIsBuffering = false // enough media to begin playback
                })
                state.audio.addEventListener('playing', () => {
                    // Audio has started playing
                    state.countCheck = 0;
                    state.lastRecordedTrackTime = -1;
                    state.timeBufferMins = 0;
                })
            } else { // pause
                state.audio.pause();
                state.isPlaying = false;
                state.isPaused = true
                state.timeLapse = false
            }
        } else if (!state.isPlaying && state.isPaused) {
            if (payload.type !== '') { // next/previous
                state.audio.src = state.tracks[payload.songId].audio;
                state.audio.play();
                // initial track timer
                state.timeBufferMins = 0
                state.currentTrackDuration = 0
                // change player controls icons
                state.isPlaying = true;
                state.isPaused = false
                state.timeLapse = true
                if (state.audio.readyState < PlayerConst.AUDIO_READY_STATE_HAVE_CURRENT_DATA) {
                    // begin buffering of track
                    state.playerIsBuffering = true
                }
                state.audio.addEventListener('loadeddata', () => {
                    state.playerIsBuffering = false // enough media to begin playback
                })
                state.audio.addEventListener('playing', () => {
                    // player has moved to +payload.type+ song
                    state.countCheck = 0;
                    state.lastRecordedTrackTime = -1;
                    state.timeBufferMins = 0;
                })
            } else { // resume playing
                state.audio.play();
                // initial track timer
                state.timeBufferMins = 0
                state.currentTrackDuration = 0
                // change player controls icons
                state.isPlaying = true;
                state.isPaused = false
                state.timeLapse = true
                if (state.audio.readyState < PlayerConst.AUDIO_READY_STATE_HAVE_CURRENT_DATA) {
                    // begin buffering of track
                    state.playerIsBuffering = true
                }
                state.audio.addEventListener('loadeddata', () => {
                    state.playerIsBuffering = false // enough media to begin playback
                })
                state.audio.addEventListener('playing', () => {
                    // Audio has resumed playing
                    state.countCheck = 0;
                    state.lastRecordedTrackTime = -1;
                    state.timeBufferMins = 0;
                })
            }
        } else if (!state.isPlaying && !state.isPaused) {
            state.progressPercent = 0 // reset playback progress
            state.audio.src = state.tracks[payload.songId].audio;
            state.audio.play();
            // initial track timer
            state.timeBufferMins = 0
            state.currentTrackDuration = 0
            // change player controls icons
            state.isPlaying = true;
            state.isPaused = false
            state.timeLapse = true
            if (state.audio.readyState < PlayerConst.AUDIO_READY_STATE_HAVE_CURRENT_DATA) {
                // begin buffering of track
                state.playerIsBuffering = true
            }
            state.audio.addEventListener('loadeddata', () => {
                state.playerIsBuffering = false // enough media to begin playback
            })
            state.audio.addEventListener('playing', () => {
                // Audio has started playing for the first time
                state.countCheck = 0;
                state.lastRecordedTrackTime = -1;
                state.timeBufferMins = 0;
            })
        }
    },
    prevSong () {
        if ((this.presentSongId - 1) >= 0) {
            this.presentSongId -= 1;
            this.play(this.presentSongId, 'prev')
        } else {
            // We\'ve arrived at the start of the playlist!
        }
        this.countCheck = 0;
        this.lastRecordedTrackTime = -1;
        this.timeBufferMins = 0;
    },
    stop (state) {
        if (state.audio) {
            state.audio.load();
            state.isPlaying = false;
            state.isPaused = false;
            // state.continuousPlay = false // halt continuous play
        } else {
            // Nothing Playing!
        }
        state.progressPercent = 0
        state.countCheck = 1
        state.lastRecordedTrackTime = -1
        state.timeBufferMins = 0
    },
    scrubToTime(state, payload){
        state.audio.currentTime = (payload.percent * state.audio.duration) / 100;
    }
}

const getters = {
    getTracks( state ) {
		return state.tracks;
	},
    getTracksLoadStatus( state ) {
		return state.tracksLoadStatus;
	},
    getCollectionName( state ) {
		return state.collectionName;
	},
    getCollectionByText( state ) {
		return state.collectionByText;
	},
    getCollectionByName( state ) {
		return state.collectionByName;
	},
    getCollectionType( state ) {
		return state.collectionType;
	},
    getCollectionId( state ) {
		return state.collectionId;
	},
    getVolume( state ) {
		return state.volume;
	},
    getProgressPercent( state ) {
		return state.progressPercent;
	},
    getTimeLapse( state ) {
		return state.timeLapse;
	}
}

const actions = {
    getTrack ({ dispatch, commit, state }, trackId) {
        state.tracksLoadStatus = 1

        PlayerAPI.getTrack(trackId)
        .then((response) => {
            state.tracksLoadStatus = 2
            // In case no collection was loaded yet before, it should play this collection
            if (!state.collectionId) {
                state.ptracks = state.tracks = response.data.tracks
                state.pcollectionId = state.collectionId = trackId
                state.pcollectionType = state.collectionType = "Track"
                state.pcollectionName = state.collectionName = response.data.tracks[0].track_original_title
                state.pcollectionByText = state.collectionByText = "Composer"
                state.pcollectionByName = state.collectionByName = response.data.tracks[0].composer
            } else {
                // Preload this collection for displaying
                state.ptracks = response.data.tracks
                state.pcollectionId = trackId
                state.pcollectionType = "Track"
                state.pcollectionName = response.data.tracks[0].track_original_title
                state.pcollectionByText = "Composer"
                state.pcollectionByName = response.data.tracks[0].composer
            }
        })
        .catch( function( e ) {
            state.tracksLoadStatus = 3
            state.ptracks = []
        })
    },
    getAlbumTracks ({ dispatch, commit, state }, albumId) {
        state.tracksLoadStatus = 1

        PlayerAPI.getAlbumTracks(albumId)
        .then((response) => {
            state.tracksLoadStatus = 2
            // In case no collection was loaded yet before, it should play this collection
            if (!state.collectionId) {
                state.ptracks = state.tracks = response.data.tracks
                state.pcollectionId = state.collectionId = albumId
                state.pcollectionType = state.collectionType = "Album"
                state.pcollectionName = state.collectionName = response.data.tracks[0].album_original_title
                state.pcollectionByText = state.collectionByText = "Composer"
                state.pcollectionByName = state.collectionByName = response.data.tracks[0].composer
            } else {
                // Preload this collection for displaying
                state.ptracks = response.data.tracks
                state.pcollectionId = albumId
                state.pcollectionType = "Album"
                state.pcollectionName = response.data.tracks[0].album_original_title
                state.pcollectionByText = "Composer"
                state.pcollectionByName = response.data.tracks[0].composer
            }
        })
        .catch( function( e ) {
            state.tracksLoadStatus = 3
            state.ptracks = []
        })
    },
    viewShit({ dispatch, commit, state }){
        setTimeout(() => {
            state.currentTrackTime = parseInt(state.audio.currentTime);
            try {
                if (!state.audio.duration) {
                    state.progressPercent = 0
                } else {
                    state.progressPercent = (state.currentTrackTime / state.audio.duration) * 100;
                }
            } catch (e) {
                state.progressPercent = (state.currentTrackTime / state.audio.duration) * 100;
            }
            //state.progressPercent = (state.currentTrackTime / state.audio.duration) * 100;
            if (state.countCheck === 0) { // initializer start check
                let ctdSecs = (parseInt(state.audio.duration) % 60) < 10 ? '0' + parseInt(state.audio.duration) % 60 : (parseInt(state.audio.duration) % 60);
                state.currentTrackDuration = isNaN(state.audio.duration) ? '0 : 00' : parseInt(parseInt(state.audio.duration) / 60) + ' : ' + ctdSecs // '0 : 00' displayed to disable showing NaN NaN
            }
            if (state.currentTrackTime !== state.lastRecordedTrackTime) {
                if (parseInt(state.audio.currentTime) >= 60) {
                    state.timeBufferMins = Math.floor(state.audio.currentTime / 60);
                    state.timeBufferSecs = parseInt(Math.floor(state.audio.currentTime)) % 60
                } else {
                    state.timeBufferSecs = parseInt(Math.floor(state.audio.currentTime))
                }
                state.duration -= 1;
                // state.timeLapse = !state.timeLapse;
                if (state.timeLapse) {
                    dispatch('viewShit')
                }

                state.countCheck += 1;
                //
                state.lastRecordedTrackTime = parseInt(Math.floor(state.audio.currentTime))
            } else {
                if (!state.audio.paused) {
                    state.isPlaying = true;
                    state.isPaused = false
                } else {
                    // state.timeBufferMins = 0;
                    // state.timeBufferSecs = 0;
                    // state.timeLapse = false; // stop time lapse
                    state.countCheck = 0; // initializer end
                    state.isPlaying = false;
                    state.isPaused = true;
                    if (state.continuousPlay && state.audio.currentTime >= state.audio.duration - 1) { // if continuous play === true
                        dispatch('nextSong')
                    }
                }
            }
        }, 1000)
    },
    playSong({ dispatch, state }, songId){
        if (state.pcollectionId != state.collectionId) {
            dispatch('changeCollection')
        }
        state.progressPercent = 0 // reset playback progress
        state.presentSongId = songId;
        state.audio.src = state.tracks[songId].audio;
        state.audio.play();
        // initial track timer
        state.timeBufferMins = 0
        state.currentTrackDuration = 0
        // change player controls icons
        state.isPlaying = true;
        state.isPaused = false
        state.timeLapse = true
        if (state.audio.readyState < PlayerConst.AUDIO_READY_STATE_HAVE_CURRENT_DATA) {
            // begin buffering of track
            state.playerIsBuffering = true
        }
        state.audio.addEventListener('loadeddata', () => {
            state.playerIsBuffering = false // enough media to begin playback
        })
        state.audio.addEventListener('playing', () => {
            // Selected song has started playing
            state.countCheck = 0;
            state.lastRecordedTrackTime = -1;
            state.timeBufferMins = 0;
            dispatch('viewShit')
        })
    },
    play({ dispatch, commit, state }, type = ''){
        if (state.pcollectionId != state.collectionId) {
            dispatch('playSong', 0)
            return
        }
        commit('play',{songId: state.presentSongId, type: type});
        if (state.timeLapse) {
            dispatch('viewShit')
        }
        state.audio.addEventListener('loadeddata', () => {
            state.playerIsBuffering = false // enough media to begin playback
        })
        state.audio.addEventListener('playing', () => {
            // Selected song has started playing
            state.countCheck = 0;
            state.lastRecordedTrackTime = -1;
            state.timeBufferMins = 0;
            dispatch('viewShit')
        })
    },
    igniteNextSong({ dispatch, state }){
        return new Promise((resolve) => {
            setTimeout(() => {
                if ((state.presentSongId + 1) <= state.lastSongId) {
                    state.presentSongId += 1;
                    dispatch('play', 'next')
                } else {
                    if (state.continuousPlay) { // if continuous play === true
                        state.presentSongId = 0;
                        dispatch('play', 'restart') // restart the playlist
                    }
                    // We\'ve arrived at the end of the playlist!
                }
                state.countCheck = 0;
                state.lastRecordedTrackTime = -1;
                state.timeBufferMins = 0;
                resolve()
            }, 10)
        })
    },
    nextSong({ dispatch }){
        return dispatch('igniteNextSong').then(()=>{
            dispatch('viewShit')
        })
    },
    ignitePrevSong({ dispatch, state }){
        return new Promise((resolve) => {
            setTimeout(() => {
                if ((state.presentSongId - 1) >= 0) {
                    state.presentSongId -= 1;
                    dispatch('play','prev')
                } else {
                    if (state.continuousPlay) { // if continuous play === true
                        state.presentSongId = state.tracks.length - 1;
                        dispatch('play', 'prestart') // restart the playlist
                    }
                    // We\'ve arrived at the start of the playlist!
                }
                state.countCheck = 0;
                state.lastRecordedTrackTime = -1;
                state.timeBufferMins = 0;
                resolve()
            }, 10)
        })
    },
    prevSong({ dispatch }){
        return dispatch('ignitePrevSong').then(()=>{
            dispatch('viewShit')
        })
    },
    igniteScrubToTime({ commit }, percent = 0){
        return new Promise((resolve) => {
            setTimeout(() => {
                commit('scrubToTime',{percent: percent});
                resolve()
            }, 10)
        })
    },
    scrubToTime({ dispatch }, percent = 0){
        return dispatch('igniteScrubToTime', percent).then(()=>{
            dispatch('viewShit')
        })
    },
    updateTimeLapse({ dispatch, commit }, timeLapse){
        commit('updateTimeLapse',{timeLapse: timeLapse});
        if(timeLapse){
            dispatch('viewShit')
        }
    },
    stop({ commit }){
        commit('stop')
    },
    changeCollection({ commit }){
        state.tracks = state.ptracks
        state.collectionId = state.pcollectionId
        state.collectionType = "Album"
        state.collectionName = state.pcollectionName
        state.collectionByText = "Composer"
        state.collectionByName = state.pcollectionByName
        state.timeLapse = true
        state.currentTrackTime = 0
        state.timeBufferSecs = 0
        state.timeBufferMins = 0
        state.lastRecordedTrackTime = -1
        state.countCheck = 0
        state.progressPercent = 0
        state.presentSongId = 0
        state.lastSongId = state.tracks.length - 1
        state.currentTrackDuration = 0
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
